// extracted by mini-css-extract-plugin
export var paginationContainer = "_83-0";